import { api } from '../../api/client'
import { useAsync } from '../../hooks/useAsync'
import { t } from '../../i18n/lingua'
import { StatCard } from '../common'

/**
 * The NIS2 programme at a glance, on top of the page: what is late, what is
 * exposed, which incident clock is running. Three small reads, each failing
 * on its own: a missing number must not hide the others.
 */
export function QuadroProgramma() {
  const scadenze = useAsync(() => api.nis2Deadlines(), [])
  const esposizione = useAsync(() => api.nis2Exposure(), [])
  const incidenti = useAsync(() => api.nis2Incidents(), [])

  const s = scadenze.data?.summary
  const e = esposizione.data?.summary
  const aperti = (incidenti.data ?? []).filter((i) => i.status !== 'chiuso')
  // The nearest notification step still to send, across open incidents.
  const prossimo = aperti
    .flatMap((i) => i.steps.filter((p) => p.hours_left != null && !p.done_at).map((p) => ({ i, p })))
    .sort((a, b) => (a.p.hours_left ?? 0) - (b.p.hours_left ?? 0))[0]
  const scaduti = aperti.reduce((n, i) => n + i.steps.filter((p) => p.state === 'scaduto').length, 0)

  return (
    <div className="stats">
      <StatCard
        label={t('Adempimenti scaduti')}
        value={s ? s.overdue : '—'}
        tone={s && s.overdue > 0 ? 'error' : 'ok'}
        hint={s ? t('{n} in scadenza nei prossimi 30 giorni, {m} da pianificare', { n: s.due_30, m: s.unplanned }) : undefined}
      />
      <StatCard
        label={t('IP esposti ad alto rischio')}
        value={e ? e.high : '—'}
        tone={e && e.high > 0 ? 'error' : 'ok'}
        hint={e ? t('{n} indirizzi esposti, {m} fuori dal perimetro', { n: e.addresses, m: e.outside_perimeter }) : undefined}
      />
      <StatCard
        label={t('Incidenti aperti')}
        value={incidenti.data ? aperti.length : '—'}
        tone={scaduti > 0 ? 'error' : aperti.length > 0 ? 'warn' : 'ok'}
        hint={
          prossimo
            ? t('{ref}: prossima notifica fra {h} h', { ref: prossimo.i.reference, h: Math.max(0, Math.round(prossimo.p.hours_left ?? 0)) })
            : scaduti > 0
              ? t('{n} notifiche scadute', { n: scaduti })
              : undefined
        }
      />
    </div>
  )
}
